import React from 'react';
import {
  withStyles,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@material-ui/core';
import { withTranslation } from 'react-i18next';

class WarningForm extends React.PureComponent {
  render() {
    const { classes, open, handleCloseForm, cancelButtonText, confirmButtonText, headerTitle, subTitle } = this.props;
    return (
      <Dialog
        open={open}
        onClose={handleCloseForm}
        aria-labelledby='form-dialog-title'
        maxWidth='sm'
        fullWidth
        PaperProps={{
          style: {
            maxWidth: '498px',
          },
        }}
      >
        <DialogTitle className='header' id='form-dialog-title'>
          <Grid item md={12} xs={12}>
            <div id='closeIcon' className={classes.closeIcon} onClick={handleCloseForm}>
              <svg width='25' height='25' viewBox='0 0 32 32'>
                <use xlinkHref={`/images/menus-v1.svg#close`} />
              </svg>
            </div>
          </Grid>
          <div className={classes.textHeader}>{headerTitle}</div>
        </DialogTitle>
        <DialogContent>
          <Grid container justify='center' item md={12} xs={12}>
            <Typography className={classes.textSubTitle}>{subTitle}</Typography>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container justify='center' style={{ margin: 20 }}>
            <Button
              id='close'
              variant='outlined'
              color='primary'
              style={{ marginRight: 20 }}
              className={classes.btnPrimary}
              onClick={handleCloseForm}
            >
              {cancelButtonText}
            </Button>
            <Button
              id='confirm'
              variant='contained'
              color='primary'
              className={classes.btnPrimary}
              onClick={this.props.handleSubmitForm}
            >
              {confirmButtonText}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  textHeader: {
    display: 'flex',
    justifyContent: 'center',
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 30,
  },
  textSubTitle: {
    fontWeight: 400,
    fontSize: 20,
  },
  btnPrimary: {
    width: 150,
    borderRadius: '4px',
  },
  closeIcon: {
    display: 'flex',
    justifyContent: 'end',
    cursor: 'pointer',
  },
});

// export const page = inject("wizard")(observer(MainOrganizationForm));
export const translation = withTranslation()(WarningForm);
export default withStyles(styles, { withTheme: true })(translation);
